export const sensor = {
  namespaced: true,
  state: {
    sensorInfo: {} // sensorKey를 key로 저장
  },
  mutations: {
    SET_SENSORS(state, sensorList) {
      sensorList.forEach(s => {
        state.sensorInfo[s.sensorKey] = s;
      });
    },
    SET_SENSOR(state, sensorData) {
      state.sensorInfo[sensorData.sensorKey] = sensorData;
    }
  },
  actions: {
    insertSensor({ commit }, sensorList) {
      commit("SET_SENSORS", sensorList);
    }
  }
};